import activeDelivery from './fetches/activeDelivery'
import appInfo from './fetches/appInfo'
import ordersDone from './fetches/ordersDone'
import orders from './fetches/orders'
import permissions from './fetches/permissions'
import withdrawals from './fetches/withdrawals'
import riderAvailability from './fetches/riderAvailability'
import balance from './fetches/balance'
import withdrawalsStats from './fetches/withdrawalsStats'
import commissionsStats from './fetches/commissionsStats'
import kyc from './fetches/kyc'
import riderProducts from './fetches/riderProducts'
import riderPurchases from './fetches/riderPurchases'
import packages from './fetches/packages'
import packagesDone from './fetches/packagesDone'
import notifications from './fetches/notifications'
import withdrawalAccounts from './fetches/withdrawalAccounts'

const data = {
  permissions,
  appInfo,
  orders,
  withdrawals,
  withdrawalAccounts,
  ordersDone,
  activeDelivery,
  riderAvailability,
  balance,
  withdrawalsStats,
  commissionsStats,
  kyc,
  riderProducts,
  riderPurchases,
  packages,
  packagesDone,
  notifications,
}

const fetchSerializers = {}
const fetchEndpoints = {}

Object.keys(data).forEach(key => {
  const item = data[key]

  const endpoint = {
    GET: item.url,
    POST: item.url,
  }
  fetchEndpoints[key] = endpoint

  class Serializer {
    get type() {
      return key
    }
    deserialize(...args) {
      return item.parse(...args)
    }
    serialize(...args) {
      return item.format(...args)
    }
  }
  fetchSerializers[key] = Serializer
})

export { fetchSerializers, fetchEndpoints }
